export const UserRole = {
  USER: "User",
  ADMIN: "Admin",
} as const;

export type UserRoleKey = keyof typeof UserRole;
export type UserRoleValue = (typeof UserRole)[UserRoleKey];

export const PaginationDefaults = {
  PAGE: 1,
  PAGE_SIZE: 10,
} as const;

